var SearchResultJson = [
    {
        country_name: "africa",
        country_handle: "africa",
        country_title: [
            { name: "Chad", search_name: "chad", handle_name: "chad", link: "/collections/worldsims"},
            {
                name: "Democratic Republic of the Congo",
                search_name: "democratic-republic-of-the-congo",
                handle_name: "democratic-republic-of-the-congo",
                link: "/collections/worldsims"},
            { name: "Egypt", search_name: "egypt", handle_name: "egypt", link: "/collections/worldsims"},
            { name: "Kenya", search_name: "kenya", handle_name: "kenya", link: "/collections/worldsims"},
            { name: "Madagascar", search_name: "madagascar", handle_name: "madagascar", link: "/collections/worldsims"},
            { name: "Morocco", search_name: "morocco", handle_name: "morocco", link: "/collections/worldsims"},
            { name: "Nigeria", search_name: "nigeria", handle_name: "nigeria", link: "/collections/worldsims"},
            {
                name: "Republic of the Congo",
                search_name: "republic-of-the-congo",
                handle_name: "republic-of-the-congo",
                link: "/collections/worldsims"},
            { name: "South Africa", search_name: "south africa", handle_name: "south-africa", link: "/collections/worldsims"},
            { name: "Tanzania", search_name: "tanzania", handle_name: "tanzania", link: "/collections/worldsims"},
            { name: "Tunisia", search_name: "tunisia", handle_name: "tunisia", link: "/collections/worldsims"},
            { name: "Uganda", search_name: "uganda", handle_name: "uganda", link: "/collections/worldsims"},
            { name: "Zambia", search_name: "zambia", handle_name: "zambia", link: "/collections/worldsims" },
        ],
        regional_name: [{ name: "Africa", search_name: "africa", handle_name: "africa", link: "/collections/worldsims"}],
    },
    {
        country_name: "asia",
        country_handle: "asia",
        country_title: [
            { name: "Bangladesh", search_name: "bangladesh", handle_name: "bangladesh", link: "/collections/bangladesh-sim-card"},
            { name: "Indonesia (Bali)", search_name: "indonesia,bali", handle_name: "indonesia", link: "/collections/indonesia-sim-card"},
            { name: "Cambodia", search_name: "cambodia", handle_name: "cambodia", link: "/collections/cambodia-sim-card"},
            { name: "China", search_name: "china", handle_name: "china", link: "/collections/china-sim-card"},
            { name: "Hong Kong", search_name: "hong kong", handle_name: "hong-kong", link: "/collections/china-sim-card"},
            { name: "India", search_name: "india", handle_name: "india", link: "/collections/india-sim-card"},
            { name: "Japan", search_name: "japan", handle_name: "japan", link: "/collections/japan-sim-card"},
            { name: "Kazakhstan", search_name: "kazakhstan", handle_name: "kazakhstan", link: "/collections/kazakhstan-sim-card"},
            { name: "Kyrgyzstan", search_name: "kyrgyzstan", handle_name: "kyrgyzstan", link: "/collections/kyrgyzstan-sim-card"},          
            { name: "Laos", search_name: "laos", handle_name: "laos", link: "/collections/laos-sim-card"},
            { name: "Macau", search_name: "macau", handle_name: "macau", link: "/collections/china-sim-card"},
            { name: "Malaysia", search_name: "malaysia", handle_name: "malaysia", link: "/collections/malaysia-sim-card"},
            { name: "Nepal", search_name: "nepal", handle_name: "nepal", link: "/collections/nepal-sim-card"},
            { name: "Pakistan", search_name: "pakistan", handle_name: "pakistan", link: "/collections/pakistan-sim-card"},
            { name: "Philippines", search_name: "philippines", handle_name: "philippines", link: "/collections/philippines-sim-card"},
            { name: "Singapore", search_name: "singapore", handle_name: "singapore", link: "/collections/singapore-sim-card"},
            { name: "South Korea", search_name: "south korea", handle_name: "south-korea", link: "/collections/south-korea-sim-card"},
            { name: "Sri Lanka", search_name: "sri lanka", handle_name: "sri-lanka", link: "/collections/sri-lanka-sim-card"},
            { name: "Taiwan", search_name: "taiwan", handle_name: "taiwan", link: "/collections/taiwan-sim-card"},
            { name: "Thailand", search_name: "thailand", handle_name: "thailand", link: "/collections/thailand-sim-card"},
            { name: "Uzbekistan", search_name: "uzbekistan", handle_name: "uzbekistan", link: "/collections/uzbekistan-sim-card"},
            { name: "Vietnam", search_name: "vietnam", handle_name: "vietnam", link: "/collections/vietnam-sim-card"},
        ],
        regional_name: [{ name: "Asia", search_name: "asia", handle_name: "asia", link: "/collections/prepaid-japan-asia-sims"}],
    },
    {
        country_name: "europe & uk",
        country_handle: "europe-uk",
        country_title: [
            { name: "Andorra", search_name: "andorra", handle_name: "andorra", link: "/collections/andorra-esim"},
            { name: "Aland Islands", search_name: "aland islands", handle_name: "aland-islands", link: "/collections/aland-islands-sim-card"},
            { name: "Albania", search_name: "albania", handle_name: "albania", link: "/collections/albania-sim-card"},
            { name: "Austria", search_name: "austria", handle_name: "austria", link: "/collections/austria-sim-card"},
            { name: "Azores", search_name: "azores", handle_name: "azores", link: "/collections/azores-sim-card"},
            { name: "Belgium", search_name: "belgium", handle_name: "belgium", link: "/collections/belgium-sim-card"},
            { name: "Bulgaria", search_name: "bulgaria", handle_name: "bulgaria", link: "/collections/bulgaria-sim-card"},
            { name: "Canary Islands", search_name: "canary islands", handle_name: "canary-islands", link: "/collections/canary-islands-sim-card"},
            { name: "Croatia", search_name: "croatia", handle_name: "croatia", link: "/collections/croatia-sim-card"},
            { name: "Cyprus", search_name: "cyprus", handle_name: "cyprus", link: "/collections/cyprus-sim-card"},
            { name: "Czech Republic", search_name: "czech republic", handle_name: "czech-republic", link: "/collections/czech-republic-sim-card"},
            { name: "Denmark", search_name: "denmark", handle_name: "denmark", link: "/collections/denmark-sim-card"},
            { name: "England", search_name: "england", handle_name: "england", link: "/collections/england-sim-card"},
            { name: "Estonia", search_name: "estonia", handle_name: "estonia", link: "/collections/estonia-sim-card"},
            { name: "Finland", search_name: "finland", handle_name: "finland", link: "/collections/finland-sim-card"},
            { name: "France", search_name: "france", handle_name: "france", link: "/collections/france-sim-card"},
            { name: "French Guiana", search_name: "french guiana", handle_name: "french-guiana", link: "/collections/french-guiana-sim-card"},
            { name: "Germany", search_name: "germany", handle_name: "germany", link: "/collections/germany-sim-card"},
            { name: "Gibraltar", search_name: "gibraltar", handle_name: "gibraltar", link: "/collections/gibraltar-sim-card"},
            { name: "Greece", search_name: "greece,rhodes island", handle_name: "greece", link: "/collections/greece-sim-card"},
            { name: "Guadeloupe", search_name: "guadeloupe", handle_name: "guadeloupe", link: "/collections/guadeloupe-sim-card"},
            { name: "Guernsey", search_name: "guernsey", handle_name: "guernsey", link: "/collections/guernsey-sim-card"},
            { name: "Hungary", search_name: "hungary", handle_name: "hungary", link: "/collections/hungary-sim-card"},
            { name: "Iceland", search_name: "iceland", handle_name: "iceland", link: "/collections/iceland-sim-card"},
            { name: "Ireland", search_name: "ireland", handle_name: "ireland", link: "/collections/ireland-sim-card"},
            { name: "Italy", search_name: "italy,sardinia,sicily", handle_name: "italy", link: "/collections/italy-sim-card"},
            { name: "Jersey", search_name: "jersey", handle_name: "jersey", link: "/collections/jersey-sim-card"},
            { name: "Latvia", search_name: "latvia", handle_name: "latvia", link: "/collections/latvia-sim-card"},
            { name: "Liechtenstein", search_name: "liechtenstein", handle_name: "liechtenstein", link: "/collections/liechtenstein-sim-card"},
            { name: "Lithuania", search_name: "lithuania", handle_name: "lithuania", link: "collections/lithuania-sim-card"},
            { name: "Luxembourg", search_name: "luxembourg", handle_name: "luxembourg", link: "collections/luxembourg-sim-card"},
            { name: "Malta", search_name: "malta", handle_name: "malta", link: "collections/malta-sim-card"},
            { name: "Moldova", search_name: "moldova", handle_name: "moldova", link: "collections/moldova-sim-card"},
            { name: "Netherlands", search_name: "netherlands", handle_name: "netherlands", link: "collections/netherlands-sim-card"},
            { name: "Norway", search_name: "Norway", handle_name: "norway", link: "collections/norway-sim-card"},
            { name: "Poland", search_name: "poland", handle_name: "poland", link: "collections/poland-sim-card"},
            { name: "Portugal", search_name: "portugal,madeira", handle_name: "portugal", link: "collections/portugal-sim-card"},
            { name: "Romania", search_name: "romania", handle_name: "romania", link: "collections/romania-sim-card"},
            { name: "Scotland", search_name: "scotland", handle_name: "scotland", link: "collections/scotland-sim-card"},
            { name: "Slovakia", search_name: "slovakia", handle_name: "slovakia", link: "collections/slovakia-sim-card"},
            { name: "Slovenia", search_name: "slovenia", handle_name: "slovenia", link: "collections/slovenia-sim-card"},
            { name: "Spain", search_name: "spain,balearic islands", handle_name: "spain", link: "collections/spain-sim-card"},
            { name: "Sweden", search_name: "sweden", handle_name: "sweden", link: "collections/spain-sim-card"},
            { name: "Switzerland", search_name: "switzerland", handle_name: "switzerland", link: "collections/switzerland-sim-card"},
            { name: "Ukraine", search_name: "ukraine", handle_name: "ukraine", link: "collections/ukraine-sim-card"},
            {
                name: "United Kingdom (UK)",
                search_name: "united kingdom (uk),northern ireland,isle of man,wales,isle of wight",
                search_extra: "uk",
                handle_name: "united-kingdom-uk",
                link: "collections/uk-europe-prepaid-sims"},
            { name: "Vatican City", search_name: "vatican city", handle_name: "vatican-city", link: "collections/vatican-city-sim-card"},
        ],
        regional_name: [{ name: "Europe & UK", search_name: "europe & uk", handle_name: "europe-uk", link: "collections/uk-europe-prepaid-sims"}],
    },
    {
        country_name: "middle east",
        country_handle: "middle-east",
        country_title: [
            { name: "Armenia", search_name: "armenia", handle_name: "armenia", link: "collections/armenia-sim-card"},
            { name: "Azerbaijan", search_name: "azerbaijan", handle_name: "azerbaijan", link: "collections/azerbaijan-sim-card"},
            { name: "Bahrain", search_name: "bahrain", handle_name: "bahrain", link: "collections/bahrain-sim-card"},
            { name: "Israel", search_name: "israel", handle_name: "israel", link: "collections/israel-sim-card"},
            { name: "Jordan", search_name: "jordan", handle_name: "jordan", link: "collections/jordan-sim-card"},
            { name: "Kuwait", search_name: "kuwait", handle_name: "kuwait", link: "collections/kuwait-sim-card"},
            { name: "Oman", search_name: "oman", handle_name: "oman", link: "collections/oman-sim-card"},
            { name: "Qatar", search_name: "qatar", handle_name: "qatar", link: "collections/qatar-sim-card"},
            { name: "Saudi Arabia", search_name: "saudi arabia", handle_name: "saudi-arabia"},
            { name: "Turkey", search_name: "turkey", handle_name: "turkey", link: "collections/turkey-sim-card"},
            {
                name: "United Arab Emirates (Dubai)",
                search_name: "united arab emirates (dubai),uae",
                search_extra: "uae,dubai",
                handle_name: "united-arab-emirates-dubai",
                link: "collections/united-arab-emirates-sim-card"},
        ],
        regional_name: [{ name: "Middle East", search_name: "middle east", handle_name: "middle-east"}],
    },
    {
        country_name: "oceania",
        country_handle: "oceania",
        country_title: [
            { name: "Fiji", search_name: "fiji", handle_name: "fiji", link: "collections/fiji-sim-card"},
            { name: "New Zealand", search_name: "new zealand", handle_name: "new-zealand", link: "/collections/nz-prepaid-sims"},
        ],
        regional_name: [{ name: "Oceania", search_name: "oceania", handle_name: "oceania", link: "collections/nz-prepaid-sims"}],
    },
    {
        country_name: "south america",
        country_handle: "south-america",
        country_title: [
            { name: "Argentina", search_name: "argentina", handle_name: "argentina", link: "collections/argentina-sim-card"},
            { name: "Brazil", search_name: "brazil", handle_name: "brazil", link: "collections/brazil-sim-card"},
            { name: "Chile", search_name: "chile", handle_name: "chile", link: "collections/chile-sim-card"},
            { name: "Colombia", search_name: "colombia", handle_name: "colombia", link: "collections/colombia-sim-card"},
            { name: "Costa Rica", search_name: "costa rica", handle_name: "costa-rica", link: "collections/costa-rica-sim-card"},
            { name: "Ecuador", search_name: "ecuador", handle_name: "ecuador", link: "collections/ecuador-sim-card"},
            { name: "El Salvador", search_name: "el salvador", handle_name: "el-salvador", link: "collections/el-salvador-sim-card"},
            { name: "Guatemala", search_name: "guatemala", handle_name: "guatemala", link: "collections/guatemala-sim-card"},
            { name: "Honduras", search_name: "honduras", handle_name: "honduras", link: "collections/honduras-sim-card"},
            { name: "Nicaragua", search_name: "nicaragua", handle_name: "nicaragua", link: "collections/nicaragua-sim-card"},
            { name: "Panama", search_name: "panama", handle_name: "panama", link: "collections/panama-sim-card"},
            { name: "Paraguay", search_name: "paraguay", handle_name: "paraguay", link: "collections/paraguay-sim-card"},
            { name: "Peru", search_name: "peru", handle_name: "peru", link: "collections/peru-sim-card"},
            { name: "Puerto Rico", search_name: "puerto rico", handle_name: "puerto-rico", link: "collections/puerto-rico-sim-card"},
            { name: "Uruguay", search_name: "uruguay", handle_name: "uruguay", link: "collections/uruguay-sim-card"},
        ],
        regional_name: [{ name: "South America", search_name: "south america", handle_name: "south-america", link: "collections/south-america-prepaid-sim-cards"}],
    },
    {
        country_name: "usa, canada & mexico",
        country_handle: "usa-canada-mexico",
        country_title: [
            { name: "Canada", search_name: "canada", handle_name: "canada", link: "collections/usa-prepaid-sims"},
            { name: "Mexico", search_name: "mexico", handle_name: "mexico", link: "collections/usa-prepaid-sims"},
            {
                name: "United States of America (USA)",
                search_name: "united states of america (usa),hawaii",
                search_extra: "usa,hawaii",
                handle_name: "united-states-of-america-usa",
                link: "collections/usa-prepaid-sims"},
        ],
        regional_name: [
            {
                name: "USA, Canada & Mexico",
                search_name: "usa, canada & mexico",
                handle_name: "usa-canada-mexico",
                link: "/collections/usa-prepaid-sims"},
        ],
    },
];




  $(document).on('click', function (event) {
    if (!$(event.target).closest('.search-section').length) {
        $('.search-wrapper-result').hide();
      $('.search-section').removeClass("search-result-open");
    }
});


  
  $('.custom_country_search').on('focus',function(){
    $('.search-wrapper-result').hide();
    $('.search-section').removeClass("search-result-open");
    $(this).parent().closest('.search-section').find('.search-wrapper-result').show();
    $(this).parent().closest('.search-section').addClass("search-result-open");
  });



  $('body').on('keyup', '.custom_country_search', function () {
     $(this).parent().closest('.search-section').find('.popular_destinations').hide();
     $(this).parent().closest('.search-section').addClass("search-result-open");
    var value = $(this).val().toLowerCase();
    var countryHtml = ' <h2 class="heading main-heading-title">Country</h2>';
    var regionHtml = '<h2 class="heading main-heading-title">Region</h2>';
    var foundRegions = new Set(); 
    var foundCountries = false;

    if (value.length > 0) {

        SearchResultJson.forEach(function(region) {
            region.country_title.forEach(function(country) {
                if (country.name.toLowerCase().includes(value.toLowerCase())) {
                    foundCountries = true;
                    countryHtml += '<li class="list-item"><a href="'+country.link+'"><div class="title-wrapper">';
                    // if (country.img) {
                    //     countryHtml += '<img src="'+country.img+'" alt="'+country.name+'" />';
                    // }
                    countryHtml += '<span class="title-name">'+country.name+'</span>';
                    countryHtml += '</div></a></li>';
        
                    if (!foundRegions.has(region.country_name)) {
                        foundRegions.add(region.country_name);
                        regionHtml += '<li class="list-item"><a href="'+region.regional_name[0].link+'"><div class="title-wrapper">';
                        // if (region.regional_name[0].img) {
                        //     regionHtml += '<img src="'+region.regional_name[0].img+'" alt="'+region.regional_name[0].name+'" />';
                        // }
                        regionHtml += '<span class="title-name">'+region.regional_name[0].name+'</span>';      
                        regionHtml += '</div></a></li>';
                    }
                }
            });
        });
      
        if (foundCountries) {
             $(this).parent().closest('.search-section').find('.country_result').html(countryHtml).show();
             $(this).parent().closest('.search-section').find('.country_region').html(regionHtml).show();
             $(this).parent().closest('.search-section').find('.no-search-item').hide();
        } else {
             $(this).parent().closest('.search-section').find('.country_result').hide();
             $(this).parent().closest('.search-section').find('.country_region').hide();
             $(this).parent().closest('.search-section').find('.no-search-item').show();
        }
        } else {
             $(this).parent().closest('.search-section').find('.popular_destinations').show();
             $(this).parent().closest('.search-section').find('.country_result').hide();
             $(this).parent().closest('.search-section').find('.country_region').hide();
             $(this).parent().closest('.search-section').find('.no-search-item').hide();
        }
});



$('body').on('click','.close_header_search',function(){
 $('header .header__search-bar-wrapper').removeClass('is-visible');
 $('header').removeClass('header--search-expanded');
 $('.nav-bar__inner').show();
  setTimeout(function(){
     $('.nav-bar').removeClass('open-search');
  },1000);

});


$('body').on('click','.header-search-icon',function(event){
  event.preventDefault();
  event.stopPropagation();
   $('header .header__search-bar-wrapper').addClass('is-visible');
   $('header').addClass('header--search-expanded');
   $('.nav-bar__inner').hide();
   $('.nav-bar').addClass('open-search');
  
});


$('body').on('click','.search-list-menu.popular_destinations li',function(){
  var URL = $(this).attr('link');
  window.location.href = URL;
});
